import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DashboardTableItem } from '../../interfaces';
import { SearchRFXQuery } from '../../interfaces/RFXBackendModel';
import { RootState } from '../../store';

interface RFXTableProps {
  query: SearchRFXQuery | undefined;
  nextToken: string | undefined;
  isLoading: boolean;
  totalCount: number;
  currentPageIndex: number;
  pagesCount: number;
  items: DashboardTableItem[];
  supplierId: string | undefined;
}

const initialState: RFXTableProps = {
  query: undefined,
  nextToken: undefined,
  isLoading: true,
  totalCount: 0,
  currentPageIndex: 1,
  pagesCount: 0,
  items: [],
  supplierId: undefined
}

const rfxTableSlice = createSlice({
  name: "rfxTable",
  initialState,
  reducers: {
    setQuery(state, action: PayloadAction<SearchRFXQuery>) {
      state.query = action.payload;
    },
    setNextToken(state, action: PayloadAction<string | undefined>) {
      state.nextToken = action.payload;
    },
    setIsSearchRFXRequestLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setTotalCount(state, action: PayloadAction<number>) {
      state.totalCount = action.payload
    },
    setCurrentPageIndex(state, action: PayloadAction<number>) {
      state.currentPageIndex = action.payload
    },
    setPagesCount(state, action: PayloadAction<number>) {
      state.pagesCount = action.payload
    },
    setItems(state, action: PayloadAction<DashboardTableItem[]>) {
      state.items = action.payload;
    },
    setSupplierId(state, action: PayloadAction<string>) {
      state.supplierId = action.payload;
    },
  },
});

export const {
  setQuery,
  setNextToken,
  setIsSearchRFXRequestLoading,
  setTotalCount,
  setCurrentPageIndex,
  setPagesCount,
  setItems,
  setSupplierId
} = rfxTableSlice.actions;

export const selectQuery = (state: RootState): SearchRFXQuery | undefined => {
  return state.rfxTable.query;
}

export const selectNextToken = (state: RootState): string | undefined => {
  return state.rfxTable.nextToken;
}

export const selectIsSearchRFXRequestLoading = (state: RootState): boolean => {
  return state.rfxTable.isLoading;
}

export const selectTotalCount = (state: RootState): number => {
  return state.rfxTable.totalCount;
}

export const selectCurrentPageIndex = (state: RootState): number => {
  return state.rfxTable.currentPageIndex;
}

export const selectPagesCount = (state: RootState): number => {
  return state.rfxTable.pagesCount;
}

export const selectItems = (state: RootState): DashboardTableItem[] => {
  return state.rfxTable.items;
}

export const selectSupplierId = (state: RootState): string | undefined => {
  return state.rfxTable.supplierId;
}

export default rfxTableSlice.reducer;
